// extracted by mini-css-extract-plugin
var _1 = "TopicUserRow-module__badgeContainer--FUCjl";
var _2 = "TopicUserRow-module__link--PiVhv";
var _3 = "TopicUserRow-module__name--tFaOC";
export { _1 as "badgeContainer", _2 as "link", _3 as "name" }
